import { DataLoadURL } from '@workflow/ecp-shared/model/dataload-url';

export const ApplicationData = {
  GetAppDetails: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'member/oao/application/details'
  } as DataLoadURL,
  GetAppSummary: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'member/oao/application'
  } as DataLoadURL,
  GetOAOOverviewBanner: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'postapplication/oao/banner'
  } as DataLoadURL,
  GetOAODashboard: {
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'member/oao/application/summaries'
  } as DataLoadURL,
  GetOAOSubmissionStatus: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'member/oao/integration/SubmitApplication/Check'
  },
  GetOLASubmissionStatus: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'GET',
    url: 'consumer/ola/dynamic/SubmitOLAApplication/Check'
  },
  GetOAOPostAppTasks: {
    defaultHeaders: { 'content-type': 'application/json' },
    hostName: 'consumerPortalApi',
    method: 'POST',
    url: 'postapplication/oao/tasks'
  } as DataLoadURL
};
